import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { navCategoryFlyout as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    shouldShowMerchantName: false,
    shouldUseRebateV2: true,
    rebateOptions: {
      hideRebatePrefix: true,
      hideElevationCurrency: true,
      tiered: {
        hideElevationCurrency: true,
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
